import React, { Component, Fragment } from 'react';
import SectionHeading from '../section-heading/SectionHeading';
import Rule from '../rule/Rule';
import { connect } from 'react-redux';
import { updateRule, updateRuleStatus } from '../redux/actions';
import { getSelectedJurisdictionCode } from '../../../../jurisdiction/redux/selectors';
import tooltip from '../../../../shared/tooltip/tooltip.json';

class ActiveRules extends Component {
    updateRule = (ruleId, ruleConfig) => {
        const { jurisdictionCode, updateRule } = this.props;
        jurisdictionCode &&
            updateRule &&
            updateRule(ruleId, ruleConfig, jurisdictionCode);
    };

    disableRule = ruleId => {
        const { jurisdictionCode, disableRule } = this.props;
        jurisdictionCode &&
            disableRule &&
            disableRule(ruleId, jurisdictionCode);
    };

    getTooltipMessage = ruleType => {
        switch (ruleType) {
            case 'DEPOSIT_LIMIT_WITHIN_GRACEPERIOD_WITHOUT_ALL_CHECKS':
                return tooltip.modifyRules.depositFundsWithNoRequiredInfo;
            default:
                return null;
        }
    };

    renderActiveRules() {
        const { rules } = this.props;

        return rules && rules.length ? (
            <Fragment>
                <div className="active-rules-content-heading">
                    <span className="heading1">Rule</span>
                    {/*<span className='heading2'>Rule Settings</span>*/}
                </div>
                {rules
                    .filter(rule => rule && rule.rule && rule.id)
                    .map(rule => (
                        <Rule
                            key={rule.id}
                            rule={rule}
                            active={true}
                            readOnly={this.props.readOnly}
                            updateRule={this.updateRule}
                            disableRule={this.disableRule}
                            tooltipMessage={null}
                        />
                    ))}
            </Fragment>
        ) : (
            <span className="rules-empty">
                No active Rules. When you turn on some of the inactive rules,
                they’ll move here.
            </span>
        );
    }

    render() {
        return (
            <Fragment>
                <SectionHeading
                    heading="Active Rules"
                    subHeading="Alerts list is affected only by active rules."
                />
                {this.renderActiveRules()}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { enabled } = state.rules.data;
    const jurisdictionCode = getSelectedJurisdictionCode(state);

    return { rules: enabled, jurisdictionCode };
};
const mapDispatchToProps = dispatch => ({
    updateRule: (ruleId, ruleConfig, jurisdictionCode) =>
        dispatch(updateRule({ ruleId, ruleConfig, jurisdictionCode })),
    disableRule: (ruleId, jurisdictionCode) =>
        dispatch(updateRuleStatus({ ruleId, enabled: false, jurisdictionCode }))
});
export default connect(mapStateToProps, mapDispatchToProps)(ActiveRules);

// Example Data:
// const activeRules = [
//     {
//         id: 1,
//         rule: 'Alert if player deposits [$${deposit_value}] before submitting info.',
//         ruleVariables: {deposit_value: '[$]2000'}
//     },
//     {
//         id: 2,
//         rule: 'User is inactive for more than [${hour} hour] [${minutes} minutes].',
//         ruleVariables: {hour: '1[ hr]', minutes:'50 [min]'}
//     },
//     {
//         id: 3,
//         rule: 'User earned more than [$${value}] in the past [${days} days].',
//         ruleVariables: {value: '[$]2000', days: '4[ days]'}
//     }
// ];
